import { baseUrl } from '../variables/Variables';
import { fetchWithCache } from '../hooks/fetchWithCache';

export const homeBaner = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("home-banner", async () => {
        const res = await fetch(`${baseUrl}api/fetch-home-banner`, settings);
        if (!res.ok) throw new Error("Failed to fetch home banner");
        return res.json();
    });
};

// Fetch About Us Banner
export const fetchHomeHeaderNumbers = async () => {
    const settings = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("home-header-numbers", async () => {
        const res = await fetch(`${baseUrl}api/fetch-emergency-contact-number`, settings);
        if (!res.ok) throw new Error("Failed to fetch header numbers");
        return res.json();
    });
};

export const techPatient = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("tech-patient-list", async () => {
        const res = await fetch(`${baseUrl}api/list-tech-patient`, settings);
        if (!res.ok) throw new Error("Failed to fetch Tech-Patient list");
        return res.json();
    });
};

export const fetchPatientStory = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("patient-story-posts", async () => {
        const res = await fetch(`${baseUrl}api/list-patient-story-post`, settings);
        if (!res.ok) throw new Error("Failed to fetch Patient Story posts");
        return res.json();
    });
};

export const fetchPatientVideos = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("patient-story-videos", async () => {
        const res = await fetch(`${baseUrl}api/list-patient-story-videos`, settings);
        if (!res.ok) throw new Error("Failed to fetch Patient Story videos");
        return res.json();
    });
};


export const upcomingEvents = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("upcoming-events", async () => {
        const res = await fetch(`${baseUrl}api/list-upcoming-events`, settings);
        if (!res.ok) throw new Error("Failed to fetch upcoming events");
        return res.json();
    });
};


export const infoHealth = async () => {
    // var Suser = JSON.parse(localStorage.getItem("userIn"));
    const settings = {
        method: "GET",
        headers: {
            // Authorization: "Bearer " + Suser.token + "",
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetchWithCache("info-health", async () => {
        const res = await fetch(`${baseUrl}api/list-better-info-health`, settings);
        if (!res.ok) throw new Error("Failed to fetch info health");
        return res.json();
    });
};

// Contact page API

export const addContact = async (contactData) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    const settings = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken,
        },
        body: JSON.stringify(contactData),
    };

    try {
        // 1️⃣ Send data to your existing API first
        const response = await fetch(baseUrl + `api/add-contact`, settings);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Error adding contact.");
        }
        const existingApiResponse = await response.json();

        // 2️⃣ If the first API call succeeds, send data to CRM
        const crmResponse = await sendToCRM(contactData);

        return { existingApiResponse, crmResponse };
    } catch (error) {
        console.error("Error in addContact:", error);
        throw error;
    }
};

const sendToCRM = async (contactData) => {
    const crmPayload = {
        first_name: contactData.name.split(" ")[0], // Extract first name
        last_name: contactData.name.split(" ")[1] || "", // Extract last name (optional)
        email: contactData.email,
        phone: contactData.phone,
        message: contactData.message,
        source: "Website ContactUs Page Form",
    };

    const crmHeaders = {
        "Content-Type": "application/json",
    };

    // Corrected API URL reference
    const crmApiUrl = baseUrl + `api/send-to-crm`;

    try {
        const response = await fetch(crmApiUrl, {
            method: "POST",
            headers: crmHeaders,
            body: JSON.stringify(crmPayload),
        });

        if (!response.ok) {
            throw new Error("Failed to send data to CRM");
        }

        return await response.json();
    } catch (error) {
        console.error("Error in sendToCRM:", error);
        return { error: "CRM API failed" };
    }
};

